import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

import DailyCounts from 'Components/common/DailyCounts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TopList from './TopList';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const TopDailyCounts = ({ globalStatistics, counts }) => {
  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext).template.dailyCounts;
  const { latestCompletedCounts } = globalStatistics;

  const { cases, deaths } = counts;

  const casesContent = {
    title: content.cases,
    variableName: content.variableNameCases,
    tooltipSuffix: content.tooltipSuffixCases,
    dailyLabel: content.CasesDailyLabel,
    avgLabel: content.AvgLabel,
    popTooltip: content.PopTooltipCases,
    noData: content.NoData,
  };

  const deathsContent = {
    title: content.deaths,
    variableName: content.variableNameDeaths,
    tooltipSuffix: content.tooltipSuffixDeaths,
    dailyLabel: content.DeathsDailyLabel,
    avgLabel: content.AvgLabel,
    popTooltip: content.PopTooltipDeaths,
    noData: content.NoData,
  };

  return (
    <div className={classnames(component, 'clearfix')}>
      <div className='section-spacer-internal' />
      <div className='clearfix'>
        <div className='daily-counts-container'>
          <DailyCounts
            content={casesContent}
            locale={locale}
            counts={cases}
            reportingThreshold={0.8}
            dateRange={['2019-12-31', latestCompletedCounts.cases]}
          />
          <div className='section-spacer-internal' />
          <div className='list-title'>
            <h6>{content.legend.titleCases} *</h6>
          </div>

          <TopList
            globalStatistics={globalStatistics}
            locale={locale}
            content={content}
          />
          <div className='section-spacer-internal' />
          <div className='desktop-key'>
            <p>* {content.legend.note}</p>
            <p>
              <FontAwesomeIcon icon={faCaretUp} /> {content.legend.increasingKey}
            </p>
            <p>
              <FontAwesomeIcon icon={faCaretDown} /> {content.legend.decreasingKey}
            </p>
          </div>
        </div>
        <div className='daily-counts-container'>
          <DailyCounts
            content={deathsContent}
            locale={locale}
            counts={deaths}
            dateRange={['2019-12-31', latestCompletedCounts.deaths]}
          />
          <div className='section-spacer-internal' />
          <div className='list-title'>
            <h6>{content.legend.titleDeaths} *</h6>
          </div>

          <TopList
            globalStatistics={globalStatistics}
            locale={locale}
            content={content}
            metric='deaths'
          />
          <div className='section-spacer-internal' />
          <div className='mobile-key'>
            <p>* {content.legend.note}</p>
            <p>
              <FontAwesomeIcon icon={faCaretUp} /> {content.legend.increasingKey}
            </p>
            <p>
              <FontAwesomeIcon icon={faCaretDown} /> {content.legend.decreasingKey}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopDailyCounts;
